import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../app/AllowedMicroservices";
import { RootState } from "../../app/store";
import apiActionCreator, { HttpMethods } from "../../services/apiActionCreator";
import { FetchStatus } from "../common/enums";
import { IUser } from "./usersSlice";

const BASE_USER_ENDPOINT = "/user";

interface SingleUserState {
  data: IUser | null;
  status: FetchStatus;
}

const initialState: SingleUserState = {
  data: null,
  status: FetchStatus.Idle,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IUser>) => {
      state.data = action.payload;
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
    clear: (state) => {
      state.data = null;
      state.status = FetchStatus.Idle;
    },
  },
});

export const { fetching, fetched, error, clear: clearUserByUsername } = userSlice.actions;

export const fetchUserByUsername = (username: string) => (
  dispatch: Dispatch<object>
) => {
  return dispatch(
    apiActionCreator({
      endpoint: `${BASE_USER_ENDPOINT}/${username}`,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.GET,
      microservice: Microservices.USER_SERVICE,
      authenticated: true,
    })
  );
};

export const selectUserByUsername = (state: RootState) => state.user.data;
export const selectUserByUsernameFetchStatus = (state: RootState) => state.user.status;
export const selectIsUserByUsernameFetching = (state: RootState) =>
  state.user.status === FetchStatus.Fetching;

export default userSlice.reducer;
